export type FaceoffTone = "red" | "blue" | "hollow";

export interface FaceoffDotProps {
  tone: FaceoffTone;
  className?: string;
}

const TONE_CLASS: Record<FaceoffTone, string> = {
  red: "bg-red",
  blue: "bg-blue",
  hollow: "border-2 border-edge bg-transparent",
};

/** 8px status mark: red = live/locked, blue = linked/active, hollow = idle/off. Decorative. */
export function FaceoffDot({ tone, className = "" }: FaceoffDotProps) {
  return (
    <span
      aria-hidden="true"
      className={`inline-block size-2 shrink-0 rounded-full ${TONE_CLASS[tone]} ${className}`}
    />
  );
}
